<template>
  <van-nav-bar
    title="课程详情"
    left-text="返回"
    left-arrow
    @click-left="onClickLeft"
    fixed
    placeholder
  />

  <!-- 加载中 -->
  <div v-if="loading" class="loading-wrap">
    <van-loading type="spinner" color="#52C1B2" />
  </div>

  <div v-else class="course-detail detail-page">
    <!-- 核心信息卡片 -->
    <div class="info-card">
      <div class="card-header">
        <h1 class="course-title">{{ detail.title }}</h1>
        <!-- <van-tag
          :color="getTypeConfig(detail.course_type, detail.cost).bg"
          :text-color="getTypeConfig(detail.course_type, detail.cost).text"
          size="medium"
        >
          {{ getTypeConfig(detail.course_type, detail.cost).textLabel }}
        </van-tag> -->
      </div>

      <!-- 基础信息列表 -->
      <div class="meta-list">
        <div v-if="detail.enrollment_title" class="meta-item">
          <van-icon name="notes-o" />
          <span class="meta-label">招生批次</span>
          <span class="meta-value">{{ detail.enrollment_title }}</span>
        </div>
        <div v-if="detail.service_week" class="meta-item">
          <van-icon name="calendar-o" />
          <span class="meta-label">上课时间</span>
          <span class="meta-value">{{ detail.service_week }}</span>
        </div>
        <div v-if="detail.service_time" class="meta-item">
          <van-icon name="clock-o" />
          <span class="meta-label">上课时段</span>
          <span class="meta-value">{{ detail.service_time }}</span>
        </div>
        <div v-if="detail.course_type !== 1 && detail.hour_cost" class="meta-item">
          <van-icon name="gold-coin-o" />
          <span class="meta-label">课时费</span>
          <span class="meta-value">
            <!-- ¥{{ detail.hour_cost }} 元/{{
              detail.class_hour ? detail.class_hour + "课时" : "课时"
            }} -->
            ¥{{ detail.hour_cost }}元{{
              Number(detail.hour_cost) > 0
                ? " /" + (detail.class_hour ? detail.class_hour + "课时" : "课时")
                : ""
            }}
          </span>
        </div>
        <div v-else class="meta-item">
          <van-icon name="gold-coin-o" />
          <span class="meta-label">材料费</span>
          <span class="meta-value"
            >¥{{ detail.cost }} 元<template v-if="detail.cost != '0.00'"> </template
          ></span>
        </div>
        <div v-if="detail.p_num" class="meta-item">
          <van-icon name="friends-o" />
          <span class="meta-label">招生人数</span>
          <span class="meta-value">{{ detail.p_num }} 人</span>
        </div>
        <div v-if="detail.start_date" class="meta-item">
          <van-icon name="play-circle-o" />
          <span class="meta-label">报名开始</span>
          <span class="meta-value">{{ formatDateTimeSafe(detail.start_date) }}</span>
        </div>
        <div v-if="detail.end_date" class="meta-item">
          <van-icon name="stop-circle-o" />
          <span class="meta-label">报名截止</span>
          <span class="meta-value">{{ formatDateTimeSafe(detail.end_date) }}</span>
        </div>
      </div>
    </div>

    <!-- 课程介绍（富文本） -->
    <div v-if="detail.course_introduction" class="section-card">
      <div class="section-title">
        <van-icon name="records" />
        <span>课程介绍</span>
      </div>
      <div class="rich-text" v-html="detail.course_introduction"></div>
    </div>

    <div style="height: 120px"></div>
  </div>

  <!-- 底部按钮 -->
  <div v-if="!loading" class="bottom-bar">
    <van-button
      :type="getButtonConfig().type"
      :class="getButtonConfig().customClass"
      :disabled="getButtonConfig().disabled"
      block
      round
      size="large"
      @click="handleButtonClick"
    >
      {{ getButtonConfig().text }}
    </van-button>
    <!-- 已报名时可撤销报名 -->
    <van-button
      v-if="detail.registration_status == 1"
      class="cancel-btn"
      type="danger"
      plain
      block
      round
      size="large"
      :loading="submitting"
      loading-text="提交中..."
      @click="handleCancelEnrollment"
    >
      取消报名
    </van-button>
  </div>

  <!-- 报名确认弹窗 -->
  <van-popup
    v-model:show="show"
    closeable
    position="bottom"
    round
    :style="{ height: '60%' }"
  >
    <div class="popup-wrap">
      <div class="popup-title">确认报名信息</div>
      <van-cell-group inset>
        <van-cell title="课程名称" :value="detail.title" />
        <van-cell
          title="课程类型"
          :value="getTypeConfig(detail.course_type, detail.cost).textLabel"
        />
        <van-cell title="上课时间" :value="detail.service_week" />
        <van-cell title="上课时段" :value="detail.service_time" />
        <van-cell
          v-if="detail.course_type === 1 && detail.cost"
          title="材料费"
          :value="'¥' + detail.cost + ' 元' + (detail.cost != '0.00' ? '' : '')"
        />
        <!-- <van-cell
          v-if="detail.course_type !== 1 && detail.hour_cost"
          title="课时费"
          :value="
            '¥' +
            detail.hour_cost +
            ' 元/' +
            (detail.class_hour ? detail.class_hour + '课时' : '课时')
          "
        /> -->

        <van-cell
          v-if="detail.course_type !== 1 && detail.hour_cost"
          title="课时费"
          :value="
            Number(detail.hour_cost) > 0
              ? '¥' +
                detail.hour_cost +
                ' 元/' +
                (detail.class_hour ? detail.class_hour + '课时' : '课时')
              : '¥' + detail.hour_cost + ' 元'
          "
        />
      </van-cell-group>
      <div class="popup-action">
        <van-button
          round
          block
          type="primary"
          size="large"
          :loading="submitting"
          loading-text="提交中..."
          @click="toOrder"
        >
          确认报名
        </van-button>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { onBeforeUnmount, onMounted, ref } from "vue";
import { Dialog, Toast } from "vant";
import { useRoute, useRouter } from "vue-router";
import "./CourseDetail.css"; // 报名按钮「未开始/已截止」灰态样式（页面作用域隔离）
import api from "../service/api";
import {
  formatDateTime,
  getEnrollWindowState,
  parseDateTime,
} from "../utils/enrollWindow";

export default {
  setup() {
    const route = useRoute();
    const router = useRouter();

    const show = ref(false);
    const loading = ref(true);
    // 报名/撤销报名进行中：与请求层去重配套，保证业务回调只跑一遍
    const submitting = ref(false);
    const enrollment_id = ref("");
    const detail = ref({});

    const COURSE_TYPE = {
      ORG: 1,
      SCHOOL: 2,
      FEATURE: 3,
    };

    const courseTypeConfig = {
      [COURSE_TYPE.ORG]: { textLabel: "校外专业导师课", bg: "#fff7e6", text: "#ff8800" },
      [COURSE_TYPE.SCHOOL]: { textLabel: "校内课程", bg: "#e6fffb", text: "#52C1B2" },
      [COURSE_TYPE.FEATURE]: { textLabel: "特色课程", bg: "#f9f0ff", text: "#7232dd" },
    };

    const getTypeConfig = (type) => {
      if (type === COURSE_TYPE.ORG) {
        return { textLabel: "校外专业导师课", bg: "#fff7e6", text: "#ff8800" };
      }
      return (
        courseTypeConfig[type] || { textLabel: "校内课", bg: "#f5f5f5", text: "#666" }
      );
    };

    // 是否为机构课（保留供将来扩展用）
    // const isOrgCourse = computed(() => detail.value.course_type === COURSE_TYPE.ORG);

    /* ---------- 报名状态（时间窗口由 utils/enrollWindow 单一来源处理） ---------- */
    const getButtonConfig = () => getEnrollWindowState(detail.value);

    // 安全展示日期（v-if 已挡 null/空串，这里兜底解析失败返空串）
    const formatDateTimeSafe = (val) => {
      const d = parseDateTime(val);
      return d ? formatDateTime(d) : "";
    };

    /* ---------- 事件 ---------- */
    const onClickLeft = () => router.go(-1);

    const handleButtonClick = () => {
      const config = getButtonConfig();
      if (config.action === "showPopup") {
        show.value = true;
      } else if (config.action === "showToast" && config.reason) {
        Toast(config.reason);
      }
    };

    // 报名
    const toOrder = () => {
      if (submitting.value) return;
      submitting.value = true;
      Toast.loading({ message: "提交中...", forbidClick: true });
      api
        .studentEnrollment({
          student_id: sessionStorage.getItem("childId"),
          enrollment_schedule_id: enrollment_id.value,
        })
        .then((res) => {
          submitting.value = false;
          if (res.data.code === 1001) {
            // 成功走 Dialog 而不是 Toast，loading 要手动关（否则会一直留到 2 秒自动消失）
            Toast.clear();
            // 本地先置位（页面立即反馈），弹框确认后再重拉对账
            show.value = false;
            detail.value.registration_status = 1;
            Dialog.alert({
              title: "报名成功",
              message: "请继续选择周一至周五的其他日期报名",
              confirmButtonText: "我知道了",
              confirmButtonColor: "#52c1b2",
            }).then(() => {
              onLoad();
            });
          } else {
            Toast.fail(res.data.message || "报名失败");
          }
        })
        .catch(() => {
          submitting.value = false;
          Toast.fail("网络异常");
        });
    };

    // 撤销报名（二次确认）
    const handleCancelEnrollment = () => {
      if (submitting.value) return;
      Dialog.confirm({
        title: "撤销报名",
        message: "确定要撤销该课程的报名吗？",
      })
        .then(() => {
          submitting.value = true;
          Toast.loading({ message: "提交中...", forbidClick: true });
          // 不依赖本地保存的 service_class_student_id（撤销/重拉后可能丢失），
          // 撤销前先查接口拿最新的报名记录 id，现查现用
          api
            .getEnrollmentById({
              enrollment_schedule_id: enrollment_id.value,
              student_id: sessionStorage.getItem("childId"),
            })
            .then((res) => {
              if (res.data.code !== 1001) {
                Toast.clear();
                Toast.fail(res.data.message || "获取报名信息失败");
                submitting.value = false;
                return null;
              }
              const serviceClassStudentId = (res.data.result || {})
                .service_class_student_id;
              if (!serviceClassStudentId) {
                Toast.clear();
                Toast.fail("当前无可撤销的报名");
                submitting.value = false;
                onLoad(); // 刷新回正确状态
                return null;
              }
              return api.cancelStudentEnrollment({
                service_class_student_id: serviceClassStudentId,
              });
            })
            .then((res) => {
              if (!res) return; // 前置查询失败/无可撤销，已处理
              submitting.value = false;
              if (res.data.code === 1001) {
                Toast.success("已撤销报名");
                detail.value.registration_status = 0;
                onLoad();
              } else {
                Toast.fail(res.data.message || "撤销失败");
              }
            })
            .catch(() => {
              Toast.clear();
              Toast.fail("网络异常");
              submitting.value = false;
            });
        })
        .catch(() => {
          // 用户取消，不处理
        });
    };

    /* ---------- 加载 ---------- */
    const onLoad = () => {
      loading.value = true;
      api
        .getEnrollmentById({
          enrollment_schedule_id: enrollment_id.value,
          student_id: sessionStorage.getItem("childId"),
        })
        .then((res) => {
          if (res.data.code === 1001) {
            detail.value = res.data.result;
          } else {
            Toast.fail(res.data.message || "获取数据失败");
          }
        })
        .catch(() => {
          Toast.fail("网络异常，请稍后重试");
        })
        .finally(() => {
          loading.value = false;
        });
    };

    /* ---------- 自动重算窗口：100ms setInterval + visibilitychange + 文案对比节流 ---------- */
    let windowTimer = null;
    let lastStateText = null;

    const refreshEnrollWindow = () => {
      // 节流：文案没变就不刷 DOM，100ms 内只在 5 个状态切换的那一帧重渲染
      const newText = getEnrollWindowState(detail.value).text;
      if (newText !== lastStateText) {
        detail.value = { ...detail.value };
        lastStateText = newText;
      }
    };

    const onVisibilityChange = () => {
      if (document.visibilityState === "visible") refreshEnrollWindow();
    };

    onMounted(() => {
      enrollment_id.value = route.query.enrollment_id;

      if (!enrollment_id.value) {
        Toast.fail("缺少报名ID");
        loading.value = false;
        return;
      }
      onLoad();
      // 100ms 一次
      windowTimer = setInterval(refreshEnrollWindow, 100);
      document.addEventListener("visibilitychange", onVisibilityChange);
    });

    onBeforeUnmount(() => {
      if (windowTimer) clearInterval(windowTimer);
      windowTimer = null;
      document.removeEventListener("visibilitychange", onVisibilityChange);
    });

    return {
      show,
      loading,
      submitting,
      detail,
      getTypeConfig,
      getButtonConfig,
      formatDateTimeSafe,
      onClickLeft,
      handleButtonClick,
      toOrder,
      handleCancelEnrollment,
    };
  },
};
</script>

<style lang="less" scoped>
.loading-wrap {
  display: flex;
  justify-content: center;
  padding-top: 80px;
}

.detail-page {
  padding: 12px;
  background-color: #f7f8fa;
  min-height: 100vh;
  box-sizing: border-box;
}

/* ---- 信息卡片 ---- */
.info-card {
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 12px;

  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 14px;

    .course-title {
      font-size: 18px;
      font-weight: bold;
      color: #1a1a1a;
      flex: 1;
      margin-right: 10px;
      line-height: 1.4;
    }
  }

  .price-row {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 10px 12px;
    background: #fff9f0;
    border-radius: 8px;
    margin-bottom: 14px;

    .price-icon {
      color: #ff8800;
      font-size: 17px;
    }
    .price-label {
      font-size: 13px;
      color: #999;
      margin-right: 4px;
    }
    .price-num {
      font-size: 22px;
      font-weight: bold;
      color: #ff4d4f;
    }
    .price-unit {
      font-size: 13px;
      color: #999;
      margin-left: 2px;
    }
  }

  .meta-list {
    .meta-item {
      display: flex;
      align-items: center;
      padding: 7px 0;
      border-bottom: 1px solid #f5f5f5;
      font-size: 14px;

      &:last-child {
        border-bottom: none;
      }

      .van-icon {
        font-size: 16px;
        color: var(--color-primary);
        margin-right: 8px;
        flex-shrink: 0;
      }
      .meta-label {
        color: #999;
        width: 68px;
        flex-shrink: 0;
      }
      .meta-value {
        color: #333;
        flex: 1;
      }
    }
  }
}

/* ---- 内容分区卡片 ---- */
.section-card {
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 12px;
  overflow: hidden;

  .section-title {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 15px;
    font-weight: bold;
    color: #1a1a1a;
    margin-bottom: 12px;
    padding-left: 4px;
    border-left: 3px solid var(--color-primary);

    .van-icon {
      font-size: 16px;
      color: var(--color-primary);
    }
  }

  .section-text {
    font-size: 14px;
    color: #555;
    line-height: 1.7;
    margin: 0;
  }

  .rich-text {
    font-size: 14px;
    color: #333;
    line-height: 1.7;
    word-break: break-all; /* 自动换行 */
    word-wrap: break-word; /* 兼容换行 */
    overflow-wrap: break-word; /* 标准换行 */

    :deep(img) {
      max-width: 100% !important; /* 图片永远不超出屏幕 */
      height: auto !important; /* 高度自适应 */
      display: block; /* 去掉图片底部空白 */
      margin: 8px 0; /* 图片上下间距 */
      border-radius: 6px;
    }

    :deep(p) {
      margin: 0 0 10px !important;
      line-height: 1.7 !important;
    }

    /* 适配所有富文本标签 */
    :deep(div),
    :deep(section),
    :deep(span),
    :deep(h1),
    :deep(h2),
    :deep(h3),
    :deep(h4) {
      max-width: 100% !important;
      box-sizing: border-box !important;
      word-break: break-all !important;
    }
    :deep(table) {
      width: 100% !important;
      display: block !important;
      overflow-x: auto !important;
      border-collapse: collapse;
      margin: 10px 0;
    }

    :deep(td),
    :deep(th) {
      word-break: break-all !important;
      padding: 6px 4px;
      border: 1px solid #eee;
    }
  }
}

/* ---- 徽章卡片 ---- */
.badge-card {
  .badge-wrap {
    display: flex;
    justify-content: center;
    padding: 8px 0;

    .badge-img {
      width: 72px;
      height: 72px;
      object-fit: contain;
    }
  }
}

/* ---- 底部按钮 ---- */
.bottom-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px 16px;
  padding-bottom: calc(10px + env(safe-area-inset-bottom));
  background: #fff;
  /* 2026-09-10 反馈：去掉顶部分界阴影，与下方按钮灰底叠加显脏（视觉像按钮自带阴影） */
  box-shadow: none;
  box-sizing: border-box;
  display: flex;
  gap: 12px;

  .van-button {
    flex: 1;
  }
}

/* 2026-09-10 「报名未开始 / 已截止」按钮用 #7EDCAC 浅绿；
 * 用 .btn-enroll-disabled 自定义类覆盖 Vant success 默认色，避免污染全局。 */
.btn-enroll-disabled {
  background: #7edcac !important;
  border-color: #7edcac !important;
  color: #ffffff !important;
}
.btn-enroll-disabled:active,
.btn-enroll-disabled.van-button--active {
  background: #6bc996 !important;
  border-color: #6bc996 !important;
}
.btn-enroll-disabled::before {
  background: #ffffff !important;
}

/* ---- 报名弹窗 ---- */
.popup-wrap {
  padding: 20px 16px;

  .popup-title {
    font-size: 17px;
    font-weight: bold;
    color: #1a1a1a;
    text-align: center;
    margin-bottom: 16px;
  }

  .popup-action {
    margin-top: 20px;
  }
}
</style>
